export const profile = {
  "MainPage.AvailabilityCalendarForm.AvailabilityCalendarForm.datePicker":
    "availability-calendar-datepicker",
  "MainPage.AvailabilityCalendarForm.AvailabilityCalendarForm.titleInput":
    "availability-calendar-title-input",
  "MainPage.RowGallery.RowGallery.editButton": "RowGallery_EditButton",
  "MainPage.RowGallery.RowGallery.photo": "RowGallery_Photo",
  "ProfileStatsPage.HelpTip.helpTipContent": "help-tip-content",
  "ProfileStatsPage.StatCard.totalViewsCount": "total-views-count",
  "LinkToProfilePage.CopyLinkButtonsSection.copyButton": "copy-button",
  "MultiSelectList.MultiSelectListItems.wrapper": "multi-select-list-items",
  "EditBasicInfo.BasicInfoForm.Nationality.nationalitiesField":
    "nationalities-field",
  "Accordion.AccordionItem.expandable-row": "expandable-row",
  "SkillsGrid.SkillsGrid-data-row": "skills-grid-row",
  "Skills.SkillsForm.skillContainer": "skill-container",
  "LinkToProfile.ProfileLink.profileLink": "profile-link",
  "LinkToProfile.CopyProfileLink.button": "profile-link-copy-button",
  "MainPage.TrainingSection": "profile-training-container",
  "MainPage.AgencyDetails.field": "profile-agency-details-heading",
  "ManageContactsPage.AgencyDetails.row": "agency-details",
  "AddAgency.AgencyFilter.dropdown": "add-agency",
  "SkillsGrid.SkillsGrid.CellValue": "skills-grid-cellValue",
  "BasicInfo.Edit.SaveButton": "basicInfo-save-button",
  "Credit.Edit.SaveButton": "credit-save-button",
  "Credit.Edit.AddButton": "credit-add-button",
  "Skill.Edit.SaveButton": "skill-save-button",
  "Media.TitaniumUploader.FileInput": "file-input",
  "Media.FilePreview.DeleteButton": "delete-button",
  "Media.VideoForm.TitleInput": "video-title-input",
  "Media.MediaForm.SaveButton": "save-form",
  "Media.Video.AddReelButton": "add-reel-button",
  "Media.Video.UploadedVideo.List": "video-list",
  "Media.Video.UploadedVideo.Title": "video-title",
  "Media.VideoItem.Loading": "video-loading-element",
  "Media.MediaStorageContainer.CapacityBar": "media-storage-capacity",
  "Media.Audio.ConfirmButton": "alert-button-test-id-stub-Confirm",
  "Media.AudioForm.TitleInput": "audio-title-input",
  "Media.Audio.UploadedAudio.List": "audio-clip",
  "Media.AudioForm.EditTitleInput": "edit-audio-title-input",
  "Media.AudioItem.Loading": "audio-loading-element",
  "Media.ThumbnailBar.ThumbnailBarItem": "thumbnailBar-element",
  "MainPage.MediaSection": "profile-media-container",
  "MainPage.MediaSection.Audio": "profile-media-visible-audio",
  "Media.Audio.ProcessingAudio": "audio-processing",
  "Media.Audio.HiddenAudio": "audio-hidden",
  "Photos.PhotographerName.Input": "photographer-name",
  "Photos.PhotographerDescription.Input": "photographer-description",
  "Photos.UploadedPhoto.card": "uploaded-photo",
  "Photo.UploadedPhoto.photoId": "photo-id",
  "Photo.UploadPhoto.input": "photo-input",
  "Photo.Headshot.editIcon": "edit-headshot",
  "Photo.Headshot.headshotOption": "photo-for-headshot",
  "Photo.Edit.confirmBtn": "alert-button-test-id-stub-Continue",
  "Photo.Headshot.headshotId": "headshot-id",
  "Photo.Headshot.headshotPhoto": "headshot-photo",
  "Photo.Overlay.Hidden": "overlay",
  "MainPage.viewMyProfile.Btn": "button-icon-View my profile",
  "Photo.EditPhoto.rotateIcon": "Rotate",
  "Photo.EditPhoto.contrastIcon": "Contrast",
  "Photo.EditPhoto.brightnessIcon": "Brightness",
  "Photo.EditPhoto.cropIcon": "Crop",
  "Photo.EditPhoto.undoIcon": "Undo",
  "Profile.Common.ControlSection": "control-section",
  "Profile.EditMode.enableButton": "editMode-enable-button",
  "Profile.EditButton": "edit-button",
  "Profile.ExpandableText.textContent": "expandable-text-content",
  "Profile.EditSectionAction.saveButton": "save-button",
  "Profile.EditSectionAction.cancelButton": "cancel-button",
  "Profile.Header.aboutMeSection": "about-me-section",
  "Profile.ProfileCard.trainingSection": "training-section",
  "Profile.ProfileCard.skillSection": "skill-section",
  "Profile.ProfileCard.skillsCategoryGroup": "skills-category-group",
  "Profile.ProfileCard.skillCategoryItem": "skills-category-item",
  "Profile.ProfileCard.basicInfoSection": "basicInfo-section",
  "Profile.ProfileCard.creditSection": "credit-section",
  "Profile.CreditSection.CreditDetail": "credit-detail",
  "Profile.ProfileCard.representationSection": "representation-section",
  "Profile.ProfileCard.mediaPlayerSection": "media-player-section",
  "Profile.ProfileCard.gallerySection": "gallery-section",
  "Profile.Agency.selfRepresentation": "self-represented",
  "Profile.Agency.agencyDetails": "agency-details",
  "Profile.Agency.agencyDetails.name": "agency-name",
  "Profile.Agency.agencyDetails.phone": "agency-phone",
  "Profile.Agency.agencyDetails.email": "agency-email",
  "Profile.Agency.agencyDetails.address": "agency-address",
  "Profile.BaicInfoSection.itemDetail": "basicInfo-item",
  "Profile.CreditsEditPage.headingList": "editCredit-heading-list",
  "Profile.CreditSection.CreditTypeTab": "credit-type-tab",
  "Profile.MediaSection.MediaVideo": "media-video",
  "Profile.MediaSection.MediaAudio": "media-audio",
  "Profile.MediaSection.MediaTitle": "media-title",
  "Profile.GallerySection.ExpandedView.GalleryCollection":
    "expandedView-gallery-collection",
  "Profile.GallerySection.Headshot": "profile-headshot",
  "Profile.SectionControl.FullScreenButton": "full-screen-button",
  "Profile.SectionControl.ExpandedViewButton": "exapand-view-button",
  "Profile.SectionControl.CloseViewButton": "close-view-vutton",
  "Profile.Header.PrintProfileButton": "print-profile-button",
};
